export default {

    set selectedFarmId(value) {
        localStorage.setItem("stockRecFilterFarmId", value);
    },
    get selectedFarmId() {
        const value = localStorage.getItem("stockRecFilterFarmId");
        return value === 'undefined' ? undefined : value;
    },
    set selectedMonth(value) {
        localStorage.setItem("stockRecFilterMonth", value);
    },
    get selectedMonth() {
        let month = localStorage.getItem("stockRecFilterMonth");
        if (month === 'undefined' || month == undefined || month == '') {
            return null;
        }

        return parseInt(month);
    },
    set selectedYear(value) {
        localStorage.setItem("stockRecFilterYear", value);
    },
    get selectedYear() {
        let year = localStorage.getItem("stockRecFilterYear");
        if (year === 'undefined' || year == undefined || year == '') {
            return null;
        }

        return parseInt(year);
    }
}